<template>
  <div v-if="isLive || chat.length">
    <stream-chart-skeleton v-if="loading" />
    <div class="stream-chat" v-else>
      <div class="chat-header" :class="{ 'hide-border-bottom': hide }">
        <div class="chat-header-title">
          <h4 class="mt-2">Live Chat</h4>
        </div>
        <div class="chat-header-internet-connection" v-if="!isOnLine">
          <i class="fas fa-exclamation-triangle"></i>
          <span>Internet connection lost</span>
        </div>
        <div
          class="chat-header-icons"
          @click="hide = !hide"
          title="Hide/Show chat"
        >
          <i class="fas fa-times" v-if="!hide"></i>
          <i class="fas fa-chevron-down" v-if="hide"></i>
        </div>
      </div>

      <div class="chat-body" v-chat-scroll v-if="!hide">
        <div
          class="chat-body-message"
          v-for="message in chat"
          :key="message.id"
        >
          <img
            src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460__340.png"
            class="user-profile"
            alt=""
            srcset=""
          />
          <div class="chat-body-message-content">
            <span class="sender-name"
              >{{ message.user.firstname + " " + message.user.lastname }}
              {{ " • " }}
            </span>
            {{ message.message }}
          </div>
        </div>
      </div>
      <form
        method="post"
        action="#"
        @submit.prevent="send_message"
        class="chat-footer"
        v-if="!hide"
      >
        <!--      User needs to be  logged in warning-->
        <div class="chat-footer-warning" v-if="!isAuth">
          <i class="fas fa-exclamation-triangle"></i>
          <span>{{ loginToChatLang }}</span>
        </div>
        <div class="chat-footer-warning" v-else-if="!isPaid">
          <i class="fas fa-exclamation-triangle"></i>
          <span>{{ payToChatLang }}</span>
        </div>

        <div class="chat-footer-input" v-if="isAuth && isPaid">
          <input
            type="text"
            v-model="message"
            placeholder="Type a message..."
          />
        </div>
        <emoji-container @emoji="insert" v-if="isAuth && isPaid" />
        <div class="chat-footer-button" v-if="isAuth && isPaid">
          <button type="submit" :disabled="sending">
            <span v-if="!sending">SEND</span>

            <loader v-else></loader>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "./shared/loader.vue";
import EmojiPicker from "vue-emoji-picker";
import EmojiContainer from "./shared/emoji-container.vue";
import streamChartSkeleton from "./stream-chart-skeleton.vue";

export default {
  name: "stream-chat",
  components: { EmojiContainer, Loader, EmojiPicker, streamChartSkeleton },
  props: [
    "itemId",
    "isAuth",
    "isPaid",
    "episodeId",
    "loginToChatLang",
    "isLive",
    "payToChatLang",
    "user",
  ],
  data() {
    return {
      message: "",
      search: "",
      chat: [],
      sending: false,
      hide: false,
      isOnLine: navigator.onLine,
      loading: true,
    };
  },
  mounted() {
    this.fetchMessage();
    $('.humgur-menu-trigger').trigger('click');
  },
  methods: {
    insert(emoji) {
      this.message += emoji;
    },
    async send_message() {
      try {
        if (this.isOnLine == false) return notify("warning", "You are offline");
        if (this.message == "") return;
        if (this.sending) return;

        this.$Progress.start();
        this.sending = true;
        const payload = {
          message: this.message,
        };

        if (this.episodeId != -1) {
          payload["episode_id"] = this.episodeId;
        }

        await axios.post("/send_message/" + this.itemId, {
          ...payload,
        });
        this.chat.push({
          message: this.message,
          user: this.user,
        });
        this.message = "";
        this.$Progress.finish();
      } catch (e) {
        notify(
          "error",
          "Something went wrong, check your internet connection and try again"
        );
        this.$Progress.fail();
      } finally {
        this.sending = false;
      }
    },
    fetchMessage() {
      window.addEventListener("online", () => {
        this.isOnLine = true;
      });
      window.addEventListener("offline", () => {
        this.isOnLine = false;
      });

      axios
        .get(this.getUrl(this.itemId, this.episodeId))
        .then((res) => {
          res.data.messages.map((message) => {
            this.chat.push(message);
          });
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          notify(
            "error",
            "Something went wrong, check your internet connection and try again"
          );
        });

      window.Echo.channel("message-channel-" + this.itemId).listen(
        "MessageEvent",
        (e) => {
          console.log("Received something");
          console.log(e);
          if (e.message.user.id == this.user.id) return;
          this.chat.push(e.message);
        }
      );
    },
    getUrl(item_id, episode_id = -1) {
      if (episode_id != -1) {
        return `/show_messages/${item_id}/${episode_id}`;
      } else {
        return `/show_messages/${item_id}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.stream-chat {
  border-radius: 10px;
  background-color: var(--color-secondary);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  border: 1px solid var(--color-light);
  margin-bottom: 10px;
}

@media screen and (max-width: 995px) {
  .stream-chat {
    margin-top: 40px;
  }
}

.hide-border-bottom {
  border-bottom: none !important;
}

.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid var(--color-light);

  .chat-header-title {
    h4 {
      color: #e2e8f0;
      font-size: 14px;
      font-weight: 500;
    }
  }

  .chat-header-icons {
    i {
      color: #e2e8f0;
      font-size: 14px;
      cursor: pointer;
    }
  }

  .chat-header-internet-connection {
    display: flex;
    align-items: center;
    color: #cad0e1;
    font-size: 13px;
    font-weight: 500;

    i {
      color: #e53e3e;
      margin-right: 5px;
    }
  }
}

.chat-body {
  height: 400px;
  overflow-y: scroll;
  padding: 10px;

  .chat-body-message {
    display: flex;
    margin-bottom: 10px;

    .user-profile {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      margin-right: 10px;
    }

    .chat-body-message-content {
      background-color: var(--color-primary);
      padding: 8px;
      border-radius: 8px;
      width: 100%;
      font-size: 13px;
      word-break: break-word;

      .sender-name {
        color: #e2e8f0;
        font-size: 13px;
        font-weight: 500;
      }
    }
  }
}

.chat-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-top: 1px solid var(--color-light);

  .chat-footer-warning {
    color: #e53e3e;
    font-size: 13px;
    font-weight: 500;
    text-align: center;
    width: 100%;
  }

  .chat-footer-input {
    width: 100%;
    margin-right: 15px;

    input {
      width: 100%;
      padding: 10px;
      padding-right: 26px !important;
      border-radius: 8px;
      border: 1px solid var(--color-light);
      background-color: #141619;
      color: #e2e8f0;
      font-size: 13px;

      &:focus {
        border: 1px solid #43527a;
      }
    }
  }

  .chat-footer-button {
    button {
      padding: 10px 20px;
      border-radius: 8px;
      border: 1px solid var(--color-light );
      background-color: var(--color-secondary);
      color: #e2e8f0;
      font-size: 13px;
      cursor: pointer;
      transition: 0.2s;

      &:hover {
        background-color: var(--color-grayish);
      }
    }
  }
}

.wrapper {
  position: relative;
  display: inline-block;
}
</style>
